import { ApolloLink } from "@apollo/client";
import { encryptPayload } from "../encryption/encrypt-payload";
import { isEncryptionNotRequired } from "../constants";

export const encryptLink = new ApolloLink((operation, forward) => {
  const bypassEncryption = isEncryptionNotRequired(
    operation.query.loc.source.body
  );

  if (!bypassEncryption) {
    const originalBody = {
      query: operation.query.loc.source.body,
      variables: operation.variables,
      operationName: operation.operationName,
    };
    const encryptedPayload = encryptPayload(originalBody);
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        is_encrypt_response: 1,
      },
      bypassEncryption: false,
      encryptedBody: encryptedPayload,
    }));
  } else {
    operation.setContext({ bypassEncryption: true });
  }

  return forward(operation);
});
